import { GridCellProps } from '@progress/kendo-react-grid';
import * as fabric from 'office-ui-fabric-react';
import { VFC } from 'react';

const styles = fabric.mergeStyleSets({
    statusIcon: {
        fontSize: 20,
        height: 25,
        width: 25,
        margin: 'auto 10px'
    }
});

const ConnectionStatusCell: VFC<GridCellProps> = ({ dataItem }) => {
    return (
        <td>
            <fabric.FontIcon
                iconName="FullCircleMask"
                className={styles.statusIcon}
                style={{ color: `${dataItem.connectionStatus ? 'green' : 'red'}` }}
            />
        </td>
    );
};

export default ConnectionStatusCell;
